var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5001V6.50008C2 6.14646 2.14048 5.80732 2.39052 5.55727C2.64057 5.30722 2.97971 5.16675 3.33333 5.16675H3.95333C4.17279 5.16678 4.38886 5.11264 4.58238 5.00914C4.77589 4.90564 4.94087 4.75597 5.06267 4.57341L5.604 3.76008C5.7258 3.57753 5.89077 3.42786 6.08429 3.32435C6.27781 3.22085 6.49388 3.16672 6.71333 3.16675H9.28667C9.50612 3.16672 9.7222 3.22085 9.91571 3.32435C10.1092 3.42786 10.2742 3.57753 10.396 3.76008L10.9373 4.57341C11.0591 4.75597 11.2241 4.90564 11.4176 5.00914C11.6111 5.11264 11.8272 5.16678 12.0467 5.16675H12.6667C13.0203 5.16675 13.3594 5.30722 13.6095 5.55727C13.8595 5.80732 14 6.14646 14 6.50008V12.5001C14 12.8537 13.8595 13.1928 13.6095 13.4429C13.3594 13.6929 13.0203 13.8334 12.6667 13.8334H3.33333C2.97971 13.8334 2.64057 13.6929 2.39052 13.4429C2.14048 13.1928 2 12.8537 2 12.5001Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.1667C9.10457 11.1667 10 10.2713 10 9.16675C10 8.06218 9.10457 7.16675 8 7.16675C6.89543 7.16675 6 8.06218 6 9.16675C6 10.2713 6.89543 11.1667 8 11.1667Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoOutlined);
export default __webpack_public_path__ + "static/media/photo-outlined.af0a2ed38d180cc61b56dcc48978b020.svg";
export { ForwardRef as ReactComponent };